import React from 'react';
import Flex from '../../data/Flex';
import UIContainer from '../UIContainer';
import UIFlex from '../UIFlex';
import UILoadingIcon from '../UILoadingIcon';
import Overlay from './Overlay';
import './LoadingOverlay.scss';
import Size from '../../data/Size';

interface ILoadingOverlayDetails{
    title?:string;
    desc?:string;
}

interface ILoadingOverlayProps{
    hide:()=>void;
    details:ILoadingOverlayDetails;
}

export default class LoadingOverlay extends React.Component<ILoadingOverlayProps>{

    static show=($id:string,$details:ILoadingOverlayDetails)=>{
        const hideOverlay = Overlay.show($id,{
            className:"loadingOverlay",
            maxWidth:330,
            noPadding:true,
            content:(
                <LoadingOverlay 
                    details={$details}                    
                    hide={()=>{
                        hideOverlay();
                    }}
                />
            ),
        });
        return hideOverlay;
    }
    
    static hide=($id:string)=>{
        Overlay.hide($id);
    }

    render(){
        let title:string = this.props.details.title || "Loading...";
        let desc:string = this.props.details.desc || "Loading Please Wait...";
        return (
            <UIFlex flex={{direction:Flex.COLUMN}}>
                <UIFlex className='loadingHeader' flex={{justifyContent:Flex.CENTER, alignItems:Flex.CENTER, overflowHidden:true}}>
                    {title}
                </UIFlex>
                <UIContainer className='loadingContent' flex={{direction:Flex.COLUMN, alignItems:Flex.CENTER, justifyContent:Flex.CENTER}} padding>
                    <UILoadingIcon fs={Size.s30}/>
                    {desc}
                </UIContainer>
            </UIFlex>
        );
    }
}

